<div
	class="flex flex-col p-6 bg-white rounded-xl border border-gray-200 justify-between min-h-64"
>
	<div>
		<!-- Image/Title -->
		<div class="flex items-center gap-x-2 h-10">
			<img
				[src]="integration.imageSource"
				[alt]="integrationKey + ' logo'"
				class="w-auto h-full max-w-28"
			/>
			<h3 class="ml-2 h3">{{ integration?.title }}</h3>
		</div>

		<!-- Description -->
		<p
			class="my-5 p text-sm text-gray-700 flex-1 items-center"
			*ngIf="integration?.description; else loadingDescription"
		>
			{{ integration.description }}
		</p>
		<ng-template #loadingDescription>
			<div class="space-y-2 pt-4">
				<div class="h-4 bg-gray-200 rounded"></div>
				<div class="h-4 bg-gray-200 rounded w-5/6"></div>
			</div>
		</ng-template>
	</div>

	<!-- Content -->
	<div
		class="flex items-center w-full justify-between"
		*ngIf="(integration.connected$ | async) !== undefined; else loading"
	>
		<!-- Sync Only Div -->
		<div *ngIf="integrationKey === 'sync'" class="flex gap-x-2 items-center">
			<i-tabler
				[name]="integration?.lawyersConnected > 0 ? 'user-filled' : 'user'"
				class="h-4 w-4"
				[ngClass]="
					integration?.lawyersConnected > 0 ? 'text-green' : 'text-grey'
				"
			/>
			<h6
				class="h6"
				[ngClass]="
					integration?.lawyersConnected > 0 ? 'text-gray-800' : 'text-gray-500'
				"
			>
				{{ integration?.lawyersConnected }}/{{ integration.totalLawyers }}
				Lawyers Connected
			</h6>
		</div>

		<!-- non-sync connected indicator -->
		<div
			class="flex items-center"
			*ngIf="(integration.connected$ | async) && integrationKey !== 'sync'"
		>
			<div class="w-2 h-2 bg-green rounded-full mr-2"></div>
			<span class="text-green">Connected</span>
		</div>

		<!-- integration action buttons -->
		<div class="flex flex-1 justify-end">
			<ui-button
				label="View"
				size="sm"
				preset="EXTRA_LOW_EMPHASIS"
				*ngIf="integration.connected$ | async"
				(click)="redirectToIntegration()"
				[testHook]="testHooks.ViewButton"
			></ui-button>
			<ui-button
				[label]="integration?.connectButtonText || 'Connect'"
				size="sm"
				preset="MEDIUM_EMPHASIS"
				*ngIf="!(integration.connected$ | async)"
				(click)="redirectToIntegration()"
				[testHook]="testHooks.Button"
			></ui-button>
		</div>
	</div>
</div>

<ng-template #loading>
	<div class="animate-pulse flex flex-col gap-4 justify-between">
		<div class="flex justify-between">
			<div class="h-8 bg-gray-200 rounded w-1/4"></div>
			<div class="h-8 bg-gray-200 rounded w-20"></div>
		</div>
	</div>
</ng-template>
